import Duck from 'extensible-duck'

const selectors = () => ({
    getVerificationProgress: new Duck.Selector(() => (state) =>  state?.utils?.verifyInProgress),
    getVerificationEmail: new Duck.Selector(() => (state) => state?.utils?.xVerifyEmail),
    getVerificationPhone: new Duck.Selector(() => (state) => state?.utils?.xVerifyPhone)
})

export default selectors
